export default () => ({
  message: null,
  messages: [],
  messageCounts: null,
  workOrderMessages: null,
  messageCategories: [
    {
      name: 'All',
      value: 0
    },
    {
      name: 'User Un-Read',
      value: 1
    },
    {
      name: 'MT Un-Read',
      value: 2
    },
    {
      name: 'MT Replied',
      value: 3
    },
    {
      name: 'MT Not Replied',
      value: 4
    }
  ]
})



// WEBPACK FOOTER //
// ./src/store/modules/messages/state.js